<template>
  <div v-if="scoreData">
    <v-row>
      <v-col cols="4"></v-col>
      <v-col cols="4" class="text-center">
        <h3 class="pb-3">{{riskLevel}}</h3>
        <h1>{{scoreData.cpaScore}}</h1>
      </v-col>
      <v-col cols="4"></v-col>
    </v-row>
    <v-row class="pt-3">
      <v-col cols="1"/>
      <v-col cols="2" class="ma-0 pa-0 text-center">VERY HIGH</v-col>
      <v-col cols="2" class="ma-0 pa-0 text-center">HIGH</v-col>
      <v-col cols="2" class="ma-0 pa-0 text-center">AVERAGE</v-col>
      <v-col cols="2" class="ma-0 pa-0 text-center">LOW</v-col>
      <v-col cols="2" class="ma-0 pa-0 text-center">MINIMUM</v-col>
      <v-col cols="1"/>
    </v-row>
    <v-row  class="pb-3">
      <v-col cols="1"/>
      <v-col cols="2" class="ma-0 pa-0">
        <v-card flat color="#D03A27" class="rounded-0" height="32px">
          <v-card-text class="ma-0 pa-0 text-center">
            <v-icon color="white"
                    class="ma-1 pa-0"
                    v-if="riskLevel==='VERY HIGH'">
              mdi-circle
            </v-icon>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="2" class="ma-0 pa-0">
        <v-card flat color="#E36244" class="rounded-0" height="32px">
          <v-card-text class="ma-0 pa-0 text-center">
            <v-icon color="white"
                    class="ma-1 pa-0"
                    v-if="riskLevel==='HIGH'">
              mdi-circle
            </v-icon>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="2" class="ma-0 pa-0">
        <v-card flat color="#F3C00F" class="rounded-0" height="32px">
          <v-card-text class="ma-0 pa-0 text-center" >
            <v-icon color="white"
                    class="ma-1 pa-0"
                    v-if="riskLevel==='AVERAGE'">
              mdi-circle
            </v-icon>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="2" class="ma-0 pa-0">
        <v-card flat color="#81CA82" class="rounded-0" height="32px">
          <v-card-text class="ma-0 pa-0 text-center" >
            <v-icon color="white"
                    class="ma-1 pa-0"
                    v-if="riskLevel==='LOW'">
              mdi-circle
            </v-icon>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="2" class="ma-0 pa-0">
        <v-card flat color="#5ABF6B" class="rounded-0" height="32px">
          <v-card-text class="ma-0 pa-0 text-center">
            <v-icon color="white"
                    class="ma-1 pa-0"
                    v-if="riskLevel==='MINIMUM'">
              mdi-circle
            </v-icon>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="1"/>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <h4>
          The reasons below indicate the information that has the most negative influence on your score:
        </h4>
        <span v-for="(cpaReason, index) in scoreData.cpaReasons" :key="index">
          {{cpaReason}}<br/>
        </span>
      </v-col>

    </v-row>
  </div>

</template>

<script>
export default {
  name: "PersonScoreGraph",
  props: ['scoreData'],
  computed: {
    riskLevel() {
      const score = Number(this.scoreData.cpaScore);
      if (score <= 605) {
        return "VERY HIGH"
      }
      if (score >= 606 && score <= 621) {
        return "HIGH"
      }
      if (score >= 622 && score <= 641) {
        return "AVERAGE"
      }
      if (score >= 642 && score <= 667) {
        return "LOW"
      }
      //> 653
      return "MINIMUM";
    }
  },
}
</script>

<style>
.rotated {
  transform: rotate(180deg);
}
</style>
